import { Grid, Typography } from '@mui/material'
import React from 'react'
import Header from '../../common/Header'
import Footer from '../../common/Footer'
import BlogShowcase from '../blog/BlogShowcase'

const PeopleHomePage = () => {
  return (
    <>
    <Header/>
    <Grid>
  {/* <BlogShowcase/> */}
    </Grid>
    <Footer/>
    
    </>
  )
}

export default PeopleHomePage